import React from 'react';
import jwt_decode from 'jwt-decode';
import "devextreme/data/odata/store";
import { createStore } from "devextreme-aspnet-data-nojquery";
import plusimg from "../../images/common/plus.png"
import exportimg from "../../images/common/xlsx.png"
import editimg from "../../images/common/pencil.png"
import onimg from "../../images/admin/on-button.png"
import offimg from "../../images/admin/off-button.png"
import history from "../history";
import {Form,Row,Modal,Button as ButtonBootstrap} from "react-bootstrap";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; 
import { exportToExcel } from '../../utils/exportMethods'; 
import '../../css/Buttons.css';
import {config} from '../../constants';
import CircleSign from '../ui/CircleSign';
import ConfirmDialog from './pages/customComponents/ConfirmDialog';
import {deleteKey} from '../../utils/exportMethods';
import Maximize from '../ui/Maximize';
import Minimize from '../ui/Minimize';
import ConfirmationModal from '../ui/ConfirmationModal';
import CustomDataGrid from './pages/customComponents/CustomDataGrid';
import apiClient from '../../utils/apiClient';
import { handleErrorResponse } from '../../utils/apiClient';

const url = config.url.URL; 
const dataSource = createStore({
  key: "publisherId",
  loadUrl: `${url}/PublisherMicroservice`,  
  deleteUrl: `${url}/PublisherMicroservice`,
  onBeforeSend: (method, ajaxOptions) => {
     ajaxOptions.headers = {  
     'accept': 'application/json',
     'Authorization': 'Bearer '+localStorage.getItem('token')
  }  
   },
   onAjaxError: (e) => {
    const { xhr, error } = e;
    handleErrorResponse(error || { message: 'Unknown error occurred.', response: xhr });
  }
});

const appName = "";//ArchicubedWeb; //Production
const LoadSubmenu = (section) =>{
  history.push(appName+'/admin' + (section != '' ? '/'+section : '')) ;
}

const exportPublishersToExcel = async (apiData) => {
  apiData.forEach(obj => {
    deleteKey(obj, 'publisherId');
    deleteKey(obj, 'vehicles');
  });

  const headers = [
    { header: 'Publisher/Vendor', key: 'name', autoFit: true },
    { header: 'Status', key: 'isEnabled', autoFit: true },
  ];

  await exportToExcel(headers, apiData, 'publishers_vendors_extract', 'Publishers & Vendors Extract');
};

class Publishersvendors extends React.Component {
    constructor(props) {
        super(props);
        this.applyFilterTypes = [{
          key: 'auto',
          name: 'Immediately'
        }, {
          key: 'onClick',
          name: 'On Button Click'
        }];
        
        this.state = {
          showFilterRow: true,
          showHeaderFilter: false,
          currentFilter: this.applyFilterTypes[0].key,
          showColumnLines: false,
          showRowLines: true,
          showBorders: true,
          rowAlternationEnabled: true,
          showModal: false,
          showEditModal: false,
          showConfirmationModal: false,
          showPublisherMenu: true,
          showAirportMenu: true,
          showVehicleMenu: true,
          showPositionMenu: true,
          fullscreen:false,
          oldCheckValue: false,
          validation: true,
          duplicatedValidation:true,
          selectedRowName:"",
        };

        this.dataGrid = null;
        this.onShowFilterRowChanged = this.onShowFilterRowChanged.bind(this);
        this.onShowHeaderFilterChanged = this.onShowHeaderFilterChanged.bind(this);
        this.onCurrentFilterChanged = this.onCurrentFilterChanged.bind(this);

        this.publisherName = React.createRef();
        this.publisherName_Edit = React.createRef();
        this.publisherIsEnabled = React.createRef();
        this.confDiag = React.createRef();
      }

      // to refresh our datagrid table and close all modals
      useRefresh = () => {
        this.dataGrid.useRefresh();
        this.setState({
          showModal: false,
          showEditModal: false,
          showConfirmationModal: false,
        });
      }

      fullscreenHandler=()=>{
        this.setState(prevState =>({fullscreen: !prevState.fullscreen}));
      }

      selectedChanged(e) {
        this.setState({
          selectedRowIndex: e.component.getRowIndexByKey(e.selectedRowKeys[0])
        });
      }
      
      handleClose = () =>{
        this.setState({ showConfirmationModal: true });
      }
  
      closeConfirmationModal = ()=>{
        this.setState({ showConfirmationModal: false });
      }
  
      doubleCloseModals=()=>{
        this.setState({showModal: false, showEditModal: false, showConfirmationModal:false});
      }
  
      handleEditClose = () =>{
          this.setState({ showConfirmationModal: true });
      }

      openModal = () => {   
        this.setState({showModal:true, duplicatedValidation: true ,
          validation:true});
      }

  onExportToExcel = () => {
    apiClient.get(`${url}/PublisherMicroservice`)
      .then(response => {
        const data = response.data;
        if (data) {
          exportPublishersToExcel(data);
          toast.success('Publishers/Vendors Excel export file has been generated');
        }
      });
  }

  onCreatePublisher = () => {
    this.setState({duplicatedValidation: true})
    let name = this.publisherName.current.value.trim();

    if (name == ""){
      this.setState({validation: false})
      return;
    }else{
      this.setState({validation: true})
    }

    let publisher = {
      Name: name,
      IsEnabled: true
    };

    apiClient.post(`${url}/PublisherMicroservice`, publisher)
    .then(response=>{
      const data = response.data;
      if(data){
        if(data.statusCode == 400){
          this.setState({duplicatedValidation: false})
          return;
        }else{
          toast.success('Publisher/Vendor has been created');
          this.doubleCloseModals();
          this.useRefresh();
      }
    }
    });  
  }
    
  openEditModal = (e) => {      
    const publisherId = e.row.key;
    const publisherName = e.row.data.name.trim();
    this.setState({duplicatedValidation: true,showEditModal:true,  validation:true});
    this.setState({selectedRowIndex: publisherId , selectedRowName : publisherName});

    const publisher = e.row.data;
    this.publisherName_Edit.current.value = publisher.name;
    this.publisherIsEnabled.current.checked = publisher.isEnabled;

    this.setState({oldCheckValue: e.row.data.isEnabled});
  }

  onEditPublisher = (e) => {
    const publisherId = this.state.selectedRowIndex;
    let name = this.publisherName_Edit.current.value.trim();

    this.setState({ duplicatedValidation: true });

    if (name == "") {
      this.setState({ validation: false })
      return;
    } else {
      this.setState({ validation: true })
    }

    const publisher = {
      publisherId: publisherId,
      Name: name,
    };

    apiClient.put(`${url}/PublisherMicroservice`, publisher)
      .then(response => {
        if (response) {
          const data = response.data;
          if (data.statusCode == 400) {
            this.setState({ duplicatedValidation: false })
            return;
          }
          if (this.state.oldCheckValue != this.publisherIsEnabled.current.checked) {
            this.confDiag.current.state.status = this.publisherIsEnabled.current.checked
            this.confDiag.current.state.inEditMode = true;
            this.confDiag.current.state.key = this.state.selectedRowIndex;
            this.confDiag.current.handleOpenConfirmDialog();
          } else {
            toast.success('Publisher/Vendor has been updated');
            this.useRefresh();
          }
        }
      });
  }
  
  showDisabledEnabledToast = (value) => {
    if(!this.confDiag.current.state.inEditMode) {
      if(!value) {
        toast.success('Publisher/Vendor has been enabled');
      }
      else {
        toast.success('Publisher/Vendor has been disabled');
      }
    }
    else {
      if(value) {
        toast.success('Publisher/Vendor has been enabled');
      }
      else {
        toast.success('Publisher/Vendor has been disabled');
      }
    }
  }

  componentDidMount(){
    
    const decoded = jwt_decode(localStorage.getItem('token'));
    this.setState({
      showAirportMenu: decoded.can_manage_airport_names === "true",
      showPublisherMenu: decoded.can_manage_publishers_vendors === "true",
      showVehicleMenu: decoded.can_manage_vehicles === "true",
      showPositionMenu: decoded.can_manage_positions === "true",
      can_export_to_excel: decoded.can_export_to_excel === "true"
    });
  }

    Checkisenabled = (e) =>{
      return e.row.data.isEnabled ;
    }

    Checkisdisabled = (e) =>{
    return !e.row.data.isEnabled ;
    }

    onDelete = (e) => {
      this.confDiag.current.state.key = e.row.data.publisherId;
      this.confDiag.current.state.status = e.row.data.isEnabled;
      this.confDiag.current.state.inEditMode = false;
      this.confDiag.current.handleOpenConfirmDialog();
    }

  render() {

    const columns = [
      { dataField: "isEnabled", caption: "Status", width: "110" },
      { dataField: "name", caption: "Publisher/Vendor", width: "100%"},
      // Add other columns specific to Profiles component
    ];
  
    const buttonColumn = [
      {text: "Edit", icon: editimg, className: "img-grid", name: "edit", onClick: this.openEditModal},
      {text: "btn_enabled", icon: onimg, hint: "Disable", visible: this.Checkisenabled, name: "delete", onClick: this.onDelete},
      {text: "btn_disabled", icon: offimg, hint: "Enable", visible: this.Checkisdisabled, name: "delete", onClick: this.onDelete},
      // Additional buttons for Profiles component
    ];

    return (
      <div className="div-body-section-details">
        <div className="div-body-section-details-header">
          <div className="div-section-title">
            <span>            
            {'Media References > Publishers/Vendors Management'}
            </span>
        </div>
        <div className="div-section-actions push">
          <button className={this.state.can_export_to_excel ? "btn-section-header" : "btn-section-header hidden" }  onClick={this.onExportToExcel}>
              <img className="img-section-header" src={exportimg} />
              <label>Export To Excel</label></button>
          <button  className="btn-section-header"  onClick={this.openModal}>
              <img className="img-section-header" src={plusimg} />
              <label>New Publisher/Vendor</label>
          </button>
        </div>
      </div>
        <div className="div-body-section-details-body">
          <div className="div-body-submenu">
            <div className={this.state.showPublisherMenu ? "div-submenu-link active" : "div-submenu-link hidden"} onClick={() => LoadSubmenu('publishersvendors')} >              
              <div class="div-submenu-label">
                    <label>Publishers/Vendors</label>
              </div> 
            </div>
            <div className={this.state.showAirportMenu ? "div-submenu-link" : "div-submenu-link hidden"}  onClick={() => LoadSubmenu('airports')} >              
              <div class="div-submenu-label">
                    <label>Airports</label>
              </div> 
            </div>
            <div  className={this.state.showVehicleMenu ? "div-submenu-link" : "div-submenu-link hidden"}  onClick={() => LoadSubmenu('vehicles')} >              
              <div class="div-submenu-label">
                    <label>Vehicles</label>
              </div>               
            </div>
            <div  className={this.state.showPositionMenu ? "div-submenu-link" : "div-submenu-link hidden"}  onClick={() => LoadSubmenu('positions')} >              
              <div class="div-submenu-label">
                <label>Positions</label>
              </div>               
            </div>
          </div>
          <div  className="div-padding-20 div-grid-result">
           <CustomDataGrid
              dataSource={dataSource}
              keyExpr="publisherId"
              ref={(ref) => (this.dataGrid = ref)}
              rowAlternationEnabled={this.state.rowAlternationEnabled}
              onSelectionChanged={this.selectionChanged}
              showFilterRow={this.state.showFilterRow}
              currentFilter={this.state.currentFilter}
              showHeaderFilter={this.state.showHeaderFilter}
              columns={columns}
              buttonColumn={buttonColumn}
            />
          </div>
        </div>
      <Modal show={this.state.showModal} onHide={this.handleClose} size="md" centered fullscreen={this.state.fullscreen}>
        <Modal.Header closeButton>
          <Modal.Title size="h6" >New Publisher/Vendor</Modal.Title>
          <button
            type="button"
            class="btn btn-primary admin-btn"
            onClick={this.fullscreenHandler}
          >
            {this.state.fullscreen ? <Maximize /> : <Minimize />}
          </button>
        </Modal.Header>
        <Modal.Body> 
        {!this.state.duplicatedValidation && <Row className="mb-3 col-md-12"><p className='mandatory-validation'>This Publisher/Vendor already exists, your updates cannot be saved. Please go back to Publishers/Vendors Management list to edit the corresponding form.</p></Row>  } 
        {!this.state.validation && this.state.duplicatedValidation && <Row className="mb-3 col-md-12"><p className='mandatory-validation'>Mandatory fields are missing. Saving of the Publisher/Vendor form is not allowed</p></Row>  } 
          <Row>
           
            <Form.Group className="mb-3 col-md-12" controlId="Name">
              <Form.Label className={`${this.state.validation ? "normal-title" : "validation-title"}`}>Name  <CircleSign/></Form.Label>
              <Form.Control type="text" placeholder="Name" ref={this.publisherName} className={`${!this.state.validation && "validation-control"}`}/>
              {!this.state.validation && <p className="p-required">Required</p>}
             
            </Form.Group>
          </Row>     
        </Modal.Body>
        <Modal.Footer>
        <ButtonBootstrap variant="primary" className='btnPrimary' onClick={this.onCreatePublisher}>
            Create Publisher/Vendor
          </ButtonBootstrap>
          <ButtonBootstrap variant="secondary" className='btnSecondary' onClick={this.handleClose}>
            Cancel
          </ButtonBootstrap>
        </Modal.Footer>
      </Modal> 
      <Modal show={this.state.showEditModal} onHide={this.handleEditClose} size="md" centered fullscreen={this.state.fullscreen}>
        <Modal.Header closeButton>
          <Modal.Title size="h6"> Edit Publisher/Vendor</Modal.Title>
          <button
            type="button"
            class="btn btn-primary admin-btn"
            onClick={this.fullscreenHandler}
          >
            {this.state.fullscreen ? <Maximize /> : <Minimize />}
          </button>
        </Modal.Header>
        <Modal.Body>
        {!this.state.duplicatedValidation && <Row className="mb-3 col-md-12"><p className='mandatory-validation'>This Publisher/Vendor already exists, your updates cannot be saved. Please go back to Publishers/Vendors Management list to edit the corresponding form.</p></Row>  } 
        {!this.state.validation && this.state.duplicatedValidation && <Row className="mb-3 col-md-12"><p className='mandatory-validation'>Mandatory fields are missing. Saving of the Publisher/Vendor form is not allowed</p></Row>  } 
          <Row>
            <Form.Group className="mb-3 col-md-12" controlId="Name">
              <Form.Label className={`${this.state.validation ? "normal-title" : "validation-title"}`}>Name  <CircleSign/></Form.Label>
              <Form.Control type="text" ref={this.publisherName_Edit} placeHolder="Name" className={`${!this.state.validation && "validation-control"}`}/>
              {!this.state.validation && <p className="p-required">Required</p>}
              <br/>
              <Form.Check type="checkbox" label="Is Enabled" ref={this.publisherIsEnabled}/>
            </Form.Group>
          </Row>
        </Modal.Body>
        <Modal.Footer>
        <ButtonBootstrap variant="primary" className='btnPrimary' onClick={this.onEditPublisher}>
            Update Publisher/Vendor
          </ButtonBootstrap>
          <ButtonBootstrap variant="secondary" className='btnSecondary' onClick={this.handleEditClose}>
            Cancel
          </ButtonBootstrap>
        </Modal.Footer>
      </Modal>

      <ConfirmationModal show={this.state.showConfirmationModal} hide={this.closeConfirmationModal} doubleCloseModals={this.doubleCloseModals} msg="Your updates won't be saved. Are you sure you want to leave this page
          ?"/>

      <ConfirmDialog ref={this.confDiag} microserviceName="PublisherMicroservice" editfunction={this.showDisabledEnabledToast} refreshfunction={this.useRefresh} title="Error" msg="You can't disable this Publisher/Vendor because it is linked to an enabled Vehicle. Please modify the Publisher/Vendor selected or go to Publishers/Vendors administration to disable the current one."></ConfirmDialog>
      <ToastContainer position="bottom-right"/>  
    </div>
    );
  }
  
    onShowFilterRowChanged(e) {
      this.setState({
        showFilterRow: e.value
      });
      this.clearFilter();
    }

    onShowHeaderFilterChanged(e) {
      this.setState({
        showHeaderFilter: e.value
      });
      this.clearFilter();
    }

    onCurrentFilterChanged(e) {
      this.setState({
        currentFilter: e.value
      });
    }

    clearFilter() {
      this.dataGrid.clearFilter();
    }
}

export default Publishersvendors;